import { TRegionDetail } from '@src/utils/i18n.utils'

const makeRegionDetailsData = () => {
  let regionDetails: TRegionDetail | null = null

  const updateRegionDetails = (newRegionDetails: TRegionDetail) => {
    regionDetails = newRegionDetails
  }

  return Object.freeze({
    getRegionDetails: () => regionDetails,
    updateRegionDetails: updateRegionDetails,
  })
}

const regionDetailsHolder = makeRegionDetailsData()

export default regionDetailsHolder
